import React, { useEffect, useState } from "react";
import "../../assets/AdminCss/card.css";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const FeaturedCard = ({ background }) => {
  return (
    <div
      className="rounded-xl wide-card position-relative"
      style={{
        background: background,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        width: "100%",
        height: "0",
        overflow: "hidden",
        margin: "5px",
        paddingBottom: "38.25%",
      }}
    >
      <div
        className="position-absolute"
        style={{ bottom: "10px", left: "10px" }}
      >
        <span
          className="bg-warning text-dark px-2 py-1 rounded-pill"
          style={{ fontSize: "12px", fontWeight: "bold" }}
        >
          Popular
        </span>
      </div>
    </div>
  );
};
const handlepopup = () => {
  toast.success("coming Soon");
};

const CategoryCard = ({ title, background, icon, url, isWide = false }) => {
  const navigate = useNavigate();
  return (
    <div
      className={`rounded-lg p-1 d-flex items-center gap-3 w-100 ${
        isWide ? "col-span-2" : ""
      }`}
      style={{
        background: background,
        backgroundSize:
          isWide && background.startsWith("url") ? "contain" : "auto",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        width: isWide ? "1172px" : "auto", // Set width only for wide cards
      }}
      onClick={() => navigate(url)}
    >
      <div className="text-white font-bold text-lg p-2">{title}</div>
      <div className="text-white ml-sm-auto mt-sm-2">
        {typeof icon === "string" ? (
          <img
            src={icon}
            alt={title}
         
            height="20"
            className="w-6 h-6"
          />
        ) : (
          icon
        )}
      </div>
    </div>
  );
};

const CategoryGrid = () => {
  const sportsCategories = [
    {
      title: "Cricket",
      background: "linear-gradient(270deg, #c435ef 0%, #662ef3 100%)",
      icon: "/assets/all_images/grid/g1.png",
      route: "/cricketreal",
    },
    {
      title: "Football",
      background: "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
      icon: "/assets/all_images/grid/g2.png",
      route: "/footballreal",
    },
    {
      title: "Tennis",
      background: "linear-gradient(91deg, #f7a545 0.66%, #d8560c 99.47%)",
      icon: "/assets/all_images/grid/g3.png",
      route: "/tennisreal",
    },
    {
      title: "Horse Racing ",
      background: "#EC4899",
      icon: "/assets/all_images/grid/g4.png",
    },
    {
      title: "GreyHound",
      background: "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
      icon: "/assets/all_images/grid/g5.png",
    },
  ];

  const casinoCategories = [
    {
      title: "Casino Lobby",
      background: "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
      icon: "/assets/all_images/grid/g6.png",
    },
    {
      title: "Teen Patti",
      background: "#EC4899",
      icon: "/assets/all_images/grid/g7.png",
    },
    {
      title: "Table Games",
      background: "linear-gradient(91deg, #f7a545 0.66%, #d8560c 99.47%)",
      icon: "/assets/all_images/grid/g8.png",
    },
    {
      title: "Live Casino",
      background: "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
      icon: "/assets/all_images/grid/g17.png",
    },
    {
      title: "Crash Games",
      background: "#EC4899",
      icon: "/assets/all_images/grid/g9.png",
    },
    {
      title: "Teen Patti",
      background: "linear-gradient(91deg, #f7a545 0.66%, #d8560c 99.47%)",
      icon: "/assets/all_images/grid/g10.png",
    },
    {
      title: "Slot Games",
      background: "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
      icon: "/assets/all_images/grid/g11.png",
    },
  ];

  const featuredCategories = [
    {
      title: "NEW INDIAN CASINO",
      background: 'url("/assets/all_images/grid/g12.png")',
      icon: "🇮🇳",
      isWide: true,
    },
    {
      title: "INDIAN PREMIER LEAGUE",
      background: 'url("/assets/all_images/grid/g13.png")',
      icon: "🏏",
      isWide: true,
    },
    {
      title: "PLAY AVIATOR",
      background: 'url("	/assets/all_images/grid/g14.png")',
      icon: "✈",
      isWide: true,
    },
    {
      title: "VIRTUAL CRICKET",
      background: 'url("/assets/all_images/grid/g15.png")',
      icon: "🏏",
      isWide: true,
    },
  ];

  const featuredBackgrounds = [
    'url("https://dabba.b-cdn.net/kheloyaar360.net/banners/36648.png")',
    'url("https://dabba.b-cdn.net/kheloyaar360.net/banners/64016.png")',
    'url("https://dabba.b-cdn.net/kheloyaar360.net/banners/36649.png")',
    'url("https://dabba.b-cdn.net/kheloyaar360.net/banners/36647.png")',
  ];

  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth < 768);
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className=" mx-auto">
      {/* Sports Categories */}
      {/* Sports Categories */}
      {/* <div className="flex flex-row gap-1 overflow-x-auto text-nowrap cursor-pointer responsive-sports mb-2">
        {sportsCategories.map((category, index) => (
          <CategoryCard
            key={`sports-${index}`}
            title={category.title}
            background={category.background}
            icon={category.icon}
            url={category.route}
          />
        ))}
      </div> */}

      {/* Casino Categories */}
      {/* <div
        className="flex flex-row gap-2 overflow-x-auto text-nowrap cursor-pointer"
        onClick={handlepopup}
      >
        {casinoCategories.map((category, index) => (
          <CategoryCard
            key={`casino-${index}`}
            title={category.title}
            background={category.background}
            icon={category.icon}
          />
        ))}
      </div> */}
      {/* Featured Categories */}
      {/* <div
        className="d-flex overflow-auto gap-1 pt-2"
        onClick={handlepopup}
        style={{ whiteSpace: "nowrap" }}
      >
        {featuredCategories.map((category, index) => {
          const imageUrl = category.background
            .replace(/^url\(["']?/, "")
            .replace(/["']?\)$/, "");
          return (
            <div
              key={`featured-cat-${index}`}
              className={`${
                isTablet ? "d-none" : "d-inline-flex"
              } align-items-center justify-content-between position-relative pointer me-2`}
              style={{ minWidth: "150px" }}
            >
              <img
                src={imageUrl}
                alt={category.title}
                className="img-fluid rounded"
              />
            </div>
          );
        })}
      </div> */}

      <div className="row g-2  hidee  row1">
        {featuredBackgrounds.map((background, index) => (
          <div key={`featured-${index}`} className="col-6 mb-1">
            <FeaturedCard background={background} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryGrid;